import { EXERCISE_DETAIL_TABS } from '@steado/admin-contract/exercises';
import { z } from 'zod';

/**
 * The open tab lives in the URL.
 *
 * Same reasoning as everywhere else in the console: "look at this exercise's
 * muscle map" is a link an operator can paste into a ticket, and the back
 * button should walk back through tabs rather than off the screen.
 *
 * `.catch` so a stale link naming a tab that was renamed lands on Overview
 * rather than on an error page.
 */
export const exerciseDetailSearchSchema = z.object({
  tab: z.enum(EXERCISE_DETAIL_TABS).default('overview').catch('overview'),
});

export type ExerciseDetailSearch = z.infer<typeof exerciseDetailSearchSchema>;
